var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Navbar"},[_c('div',{staticClass:"Navbar__Logo"},[_c('Picture',{attrs:{"name":"logo-daas-white"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }